export var ETH = 1;
export var POL = 2;
export var BNB = 3;
export var TRX = 4;
export var BTC = 7;
export var USDT = 9;



// WEBPACK FOOTER //
// ./src/constants/CryptoCurrencies.js